export default __webpack_public_path__ + "static/3-158df81d279735f57dd71b12f37bf529.png";